module.exports = __webpack_public_path__ + "static/media/andreAlen.41bc116e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/andreAlen.jpg
// module id = 1662
// module chunks = 1